import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { Form, InputGroup, Input, ButtonGroup, Button, Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { capitalizeFirstLetter } from '../../../../util/text';
import { sequence } from '../../../../util/promises';

import { getInstitutions } from '../../../Institution/InstitutionActions';
import { getUsers, getLoggedUser } from '../../../User/UserActions';
import { getSubjectsRequest, getSubjects, canEditSubject } from '../../../Subject/SubjectActions';
import { getThemesRequest, getThemes } from '../../../Theme/ThemeActions';
import { getSessionsRequest, getSessions, canEditSession, canProctorSession, canCorrectSession, getSessionStatusColor, SESSION_STATUS_PENDING, SESSION_STATUS_ONPROGRESS, SESSION_STATUS_DONE, SESSION_STATUS_ONCORRECTION, SESSION_STATUS_CORRECTED, SESSION_STATUS_ARCHIVED, canAddApplicant } from '../../../Session/SessionActions';

class SearchMini extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFocus: false,
            search: '',
        };
    }

    handleChange = event => {
        const { target } = event;
        const { name, value } = target;
        this.setState({
            [name]: value,
        }, () => {
            setTimeout(() => {
                if(name === 's' && this.state.search.length > 2 && this.state.search && this.state.search === value) {
                    sequence([getSessionsRequest, getSubjectsRequest, getThemesRequest].map(caller => (() => caller(this.state.search))), this.props.dispatch);
                    // this.props.dispatch(getSessionsRequest(this.state.search));
                    // this.props.dispatch(getSubjectsRequest(this.state.search));
                    // this.props.dispatch(getThemesRequest(this.state.search));
                } else {
                    console.log('Search not allowed', this.state.search, value);
                }
            }, 400);
        });
    };

    toggleFocus = event => {
        setTimeout(() => {
            this.setState({
                isFocus: !this.state.isFocus,
            });
        }, 200);
    };

    renderResults() {
        if(this.state.search && this.state.search.length > 2 && this.state.isFocus) {
            return (
                <div className="w-100 py-3 px-2 bg-white border shadow" style={{ position: 'absolute', width: '100%', zIndex: '10', maxHeight: '300px', overflow: 'auto' }}>
                    {this.renderSessionsResults()}
                    {['root', 'admin', 'manager'].includes(this.props.user.role) && this.renderInstitutionsResults()}
                    {['root', 'admin', 'manager', 'professor'].includes(this.props.user.role) && this.renderUsersResults()}
                    {this.renderSubjectsResults()}
                    {this.renderThemesResults()}
                </div>
            );
        }
        return null;
    }

    renderInstitutionsResults() {
        const institutions = this.props.institutions.filter(institution => institution.name.toLowerCase().includes(this.state.search.toLowerCase()));
        if(institutions && institutions.length) {
            return (
                <div className="mb-2 pt-2">
                    <h6 className="text-primary"><FontAwesomeIcon icon="university" /> <FormattedMessage id="institutions" defaultMessage="Institutions" /></h6>
                    {institutions.map(institution => (
                        <div key={institution._id} className="d-flex justify-content-between ms-3 my-1 py-1 border-bottom">
                            <strong>{institution.name}</strong>
                            <Button outline size="sm" tag={Link} to={`/console/institution/${institution._id}`}><FontAwesomeIcon icon="eye" /></Button>
                        </div>
                    ))}
                </div>
            );
        }
    }

    renderUsersResults() {
        const users = this.props.users.filter(user => (user.firstName || '').toLowerCase().includes(this.state.search.toLowerCase())
            || (user.lastName || '').toLowerCase().includes(this.state.search.toLowerCase())
            || (user.email || '').toLowerCase().includes(this.state.search.toLowerCase())
            || user._id === this.state.search);
        if(users && users.length) {
            return (
                <div className="mb-2 pt-2">
                    <h6 className="text-primary"><FontAwesomeIcon icon="user" /> <FormattedMessage id="users" defaultMessage="Users" /></h6>
                    {users.map(user => (
                        <div key={user._id} className="d-flex justify-content-between ms-3 my-1 py-1 border-bottom">
                            <div>
                                <strong>{`${user.firstName} ${user.lastName}`}</strong><br />
                                <em>{user.email}</em>
                            </div>
                            <Button outline size="sm" tag={Link} to={`/console/user/${user._id}`}><FontAwesomeIcon icon="eye" /></Button>
                        </div>
                    ))}
                </div>
            );
        }
    }

    renderThemesResults() {
        const themes = this.props.themes.filter(theme => (theme.label || '').toLowerCase().includes(this.state.search.toLowerCase())
            || (theme.domain || '').toLowerCase().includes(this.state.search.toLowerCase())
            || (theme.matter || '').toLowerCase().includes(this.state.search.toLowerCase())
            || theme._id === this.state.search);
        if(themes && themes.length) {
            return (
                <div className="mb-2 pt-2">
                    <h6 className="text-primary"><FontAwesomeIcon icon="folder" /> <FormattedMessage id="themes" defaultMessage="Themes" /></h6>
                    {themes.map(theme => (
                        <div key={theme._id} className="d-flex justify-content-between ms-3 my-1 py-1 border-bottom">
                            <div>
                                <strong>{theme.label}</strong><br />
                                <em>{theme.language} > {theme.domain} > {theme.matter}</em>
                            </div>
                            <ButtonGroup size="sm">
                                <Button outline tag={Link} to={`/console/theme/${theme._id}`}><FontAwesomeIcon icon="eye" /></Button>
                                <Button color="primary" outline tag={Link} to={`/console/subjects?s=${theme.label}`}><FontAwesomeIcon icon="copy" /></Button>
                            </ButtonGroup>
                        </div>
                    ))}
                </div>
            );
        }
    }

    renderSubjectsResults() {
        const subjects = this.props.subjects.filter(subject => canEditSubject(subject, this.props.user)
            && (
                (subject.title || '').toLowerCase().includes(this.state.search.toLowerCase())
                || (subject.resume && subject.resume.toLowerCase().includes(this.state.search.toLowerCase()))
                || (subject.tags && subject.tags.some(tag => tag.toLowerCase().includes(this.state.search.toLowerCase())))
                || subject._id === this.state.search
            ));
        if(subjects && subjects.length) {
            return (
                <div className="mb-2 pt-2">
                    <h6 className="text-primary"><FontAwesomeIcon icon="edit" /> <FormattedMessage id="subjects" defaultMessage="Subjects" /></h6>
                    {subjects.map(subject => (
                        <div key={subject._id} className="d-flex justify-content-between ms-3 my-1 py-1 border-bottom">
                            <div>
                                <strong>{subject.title}</strong><br />
                                {subject.tags.map((tag, index) => <span key={index}><Badge color="primary">{tag}</Badge>{' '}</span>)}
                            </div>
                            <ButtonGroup size="sm">
                                <Button outline tag={Link} to={`/console/subject/${subject._id}`}><FontAwesomeIcon icon="eye" /></Button>
                                <Button color="primary" outline tag={Link} to={`/console/subject/${subject._id}/questions`}><FontAwesomeIcon icon="list" /></Button>
                                <Button color="info" outline tag={Link} to={`/console/subject/${subject._id}/variables`}><FontAwesomeIcon icon="palette" /></Button>
                            </ButtonGroup>
                        </div>
                    ))}
                </div>
            );
        }
    }

    renderSessionsResults() {
        const sessions = this.props.sessions.filter(session => (canEditSession(session, this.props.user) || canProctorSession(session, this.props.user))
            && (
                (session.label || '').toLowerCase().includes(this.state.search.toLowerCase())
                || (session.code || '').toLowerCase().includes(this.state.search.toLowerCase())
                || session._id === this.state.search
            ));
        if(sessions && sessions.length) {
            return (
                <div className="mb-2 pt-2">
                    <h6 className="text-primary"><FontAwesomeIcon icon="paper-plane" /> <FormattedMessage id="sessions" defaultMessage="Sessions" /></h6>
                    {sessions.map(session => (
                        <div key={session._id} className="d-flex justify-content-between ms-3 my-1 py-1 border-bottom">
                            <div>
                                <strong>{session.label}</strong> <em>{session.degree}</em><br />
                                <Badge color={getSessionStatusColor(session.status)}><FormattedMessage id={`sessionStatus${capitalizeFirstLetter(session.status)}`} defaultMessage={capitalizeFirstLetter(session.status)} /></Badge>
                            </div>
                            <ButtonGroup size="sm">
                                {(['root'].includes(this.props.user.role) || (canEditSession(session, this.props.user) && [SESSION_STATUS_PENDING, SESSION_STATUS_ONPROGRESS].includes(session.status))) && <Button outline tag={Link} to={`/console/session/${session._id}`}><FontAwesomeIcon icon="pen" /></Button>}
                                {(['root'].includes(this.props.user.role) || (canEditSession(session, this.props.user) && session.status === SESSION_STATUS_PENDING)) && <Button color="primary" outline tag={Link} to={`/console/session/${session._id}/applicants`}><FontAwesomeIcon icon="list" /></Button>}
                                {(['root'].includes(this.props.user.role) || (canProctorSession(session, this.props.user) && session.status === SESSION_STATUS_ONPROGRESS)) && <Button color="info" tag={Link} to={`/console/session/${session._id}/proctor`}><FontAwesomeIcon icon="eye" /></Button>}
                                {(['root'].includes(this.props.user.role) || canCorrectSession(session, this.props.user)) && <Button color="warning" tag={Link} to={`/console/session/${session._id}/correction`}><FontAwesomeIcon icon="highlighter" /></Button>}
                            </ButtonGroup>
                        </div>
                    ))}
                </div>
            );
        }
    }

    render() {
        return (
            <Form className="me-auto ms-md-3 my-2 my-md-0 mw-100 navbar-search" style={{ position: 'relative', width: '30%' }} onSubmit={event => event.stopPropagation()}>
                <InputGroup>
                    <Input type="text" bsSize="sm" name="search" value={this.state.search} onChange={this.handleChange} onFocus={this.toggleFocus} onBlur={this.toggleFocus} className=" border-top-0 border-left-0 small" placeholder={this.props.intl.formatMessage({ id: 'searchFor', defaultMessage: 'Search...' })} aria-label="Search" />

                    <Button color="secondary" size="sm">
                        <FontAwesomeIcon icon="search" />
                        <span className="d-none">Search</span>
                    </Button>
                </InputGroup>
                {this.renderResults()}
            </Form>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
        institutions: getInstitutions(store),
        users: getUsers(store),
        subjects: getSubjects(store),
        themes: getThemes(store),
        sessions: getSessions(store),
    };
}

SearchMini.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    institutions: PropTypes.arrayOf(PropTypes.object),
    users: PropTypes.arrayOf(PropTypes.object),
    subjects: PropTypes.arrayOf(PropTypes.object),
    themes: PropTypes.arrayOf(PropTypes.object),
    sessions: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(withIntl(SearchMini));
